
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Banner.css';
import { faSortDown } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-scroll';

const Banner = () => {

    return (
        <>
            <section id="banner">
                <div class="container">
                    <div class="row">
                        <div class="col-md-5">
                            <h1 class="promo-title">ADK Shotokan</h1>
                            <div class="wrapper">
                                <p><mark>Excelência em</mark></p>
                                <div class="words">
                                    <span><mark>disciplina.</mark></span>
                                    <span><mark>dedicação.</mark></span>
                                    <span><mark>respeito.</mark></span>
                                    <span><mark>karatê.</mark></span>
                                    <span><mark>disciplina.</mark></span>
                                </div>
                            </div>

                        </div>
                        <div class="col-md text-center">
                            <img src={`${process.env.PUBLIC_URL}/home/cumprimento.svg`} alt="" srcset="" class="img-fluid" id="img-home"/>
                            <Link to="video" smooth={true} duration={500} offset={-100} >
                                <button type="button" class="btn btn-primary mt-2">Conhecer</button>
                            </Link>
                        </div>
                    </div>
                    <div id="descer">
                        <a class="botaodown">
                            <Link to="services" smooth={true} duration={500} offset={-100} >
                                <FontAwesomeIcon icon={faSortDown} />
                            </Link>
                        </a>
                    </div>
                </div>

                <img src={`${process.env.PUBLIC_URL}/home/bottom.svg`} class="bottom-img"/>

            </section>

        </>
    )

}

export default Banner;
